
const WhoWeAre = () => {
    return (
        <section id="about" className="pdtopBottmSection">
        <div className="container">
        <div className="about-image-wrap reveal">
            <img src="https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1200&q=80" alt="Istanbul property exterior" />
            <div className="about-image-overlay">
            <p>“Your gateway to Turkish real estate.”</p>
            <span>EST. ISTANBUL</span>
            </div>
        </div>

        <div className="about-content reveal">
            <div className="section-label">Who We Are</div>
            <div className="section-title">A New Standard<br/>for <em>Overseas</em><br/>Investment</div>
            <p className="about-body">INVESTA ESTATES is an Istanbul-based real estate agency specialising in connecting overseas investors with premium residential opportunities across Turkey’s most dynamic property markets.</p>
            <p className="about-body">From off-plan acquisitions in Kağıthane to waterfront developments in Kocaeli, we provide end-to-end guidance — sourcing, legal structuring, citizenship pathways, and post-purchase management.</p>

            <div className="about-features">
            <div className="about-feature">
                <div className="about-feature-icon">🏙️</div>
                <div className="about-feature-title">Prime Locations</div>
                <div className="about-feature-text">Istanbul and Kocaeli’s most sought-after districts for international buyers.</div>
            </div>
            <div className="about-feature">
                <div className="about-feature-icon">⚖️</div>
                <div className="about-feature-title">Legal Guidance</div>
                <div className="about-feature-text">Clear documentation support from reservation to title deed transfer.</div>
            </div>
            <div className="about-feature">
                <div className="about-feature-icon">🌍</div>
                <div className="about-feature-title">Global Reach</div>
                <div className="about-feature-text">Built for overseas investors seeking growth, lifestyle, and security.</div>
            </div>
            <div className="about-feature">
                <div className="about-feature-icon">🔑</div>
                <div className="about-feature-title">End-to-End Service</div>
                <div className="about-feature-text">From property search to post-purchase support and rental assistance.</div>
            </div>
            </div>
        </div>
        </div>
    </section>
    )
}

export default WhoWeAre;